<template>
  <div class="addProblem">
    <div
      class="publicTitle display-flex justify-content-space-between align-items-center"
    >
      <h5 class="h5">
        <img src="../../assets/img/titleLine.png" alt /> 添加问题
      </h5>
    </div>
    <div class="from">
      <Form
        class="head-login"
        ref="from"
        :model="msg"
        :rules="rules"
        :label-width="90"
        :hide-required-mark="true"
      >
        <FormItem label="我的问题" prop="content">
          <Input
            @on-change="handleChangeVal"
            v-model="msg.content"
            type="textarea"
            :autosize="{ minRows: 6 }"
            placeholder="请输入您的问题"
          ></Input>
          <div class="limit">100字以内</div>
        </FormItem>
        <div class="btn display-flex">
          <FormItem>
            <Button
              class="confirm"
              type="primary"
              :loading="btnLoading"
              @click="handleSubmit('from')"
              >确认提交</Button
            >
          </FormItem>

          <Button class="back" type="primary" @click="$router.back()"
            >返回</Button
          >
        </div>
      </Form>
    </div>
  </div>
</template>

<script>
import { postData, showLoading } from "../../assets/api/api.js";
export default {
  name: "addProblem",
  components: {},
  data() {
    return {
      msg: {
        content: "",
      },
      btnLoading: false,
      rules: {
        content: [
          { required: true, message: "内容不能为空", trigger: "blur" },
          {
            type: "string",
            max: 100,
            message: "你输入的字数超过了100个字",
            trigger: "change",
          },
        ],
      },
    };
  },
  created() {},
  mounted() {},
  computed: {},
  methods: {
    handleChangeVal(e) {},
    handleSubmit(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          const { msg } = this;
          var params = {
            content: msg.content,
          };
          this.btnLoading = true;
          postData("message/saveMessage", params)
            .then((res) => {
              this.$Message.success("添加成功");
              this.btnLoading = false;
              this.$router.back();
            })
            .catch((err) => {
              this.btnLoading = false;
            });
        }
      });
    },
  },
};
</script>
<style>
.addProblem .ivu-form-item-content {
  position: relative;
}
.addProblem .limit {
  color: #999999;
  position: absolute;
  right: 20px;
  bottom: 0;
}
.addProblem .ivu-btn-primary {
  margin-top: 6px;
  width: 120px;
  height: 36px;
  background: rgba(34, 34, 34, 1);
  border-radius: 4px;
  line-height: 36px;
  border: none;
}
.addProblem .back:hover {
  color: #222;
}
.addProblem .back {
  color: #222;
  margin-left: 20px;
  width: 80px !important;
  height: 36px;
  border: 1px solid rgba(34, 34, 34, 1) !important;
  border-radius: 4px;
  background: #fff !important;
}
.addProblem .ivu-btn-primary:hover {
  background: rgba(34, 34, 34, 1);
}
.addProblem .ivu-form .ivu-form-item-label {
  text-align: left;
  font-size: 16px;
  padding-top: 0;
}
textarea.ivu-input {
  background: #fafafc;
  resize: none;
  color: #999999;
}
</style>
<style lang="scss" scoped>
.addProblem {
  margin-bottom: 20px;
  width: 962px;
  float: right;
  background: #fff;

  .from {
    padding-left: 45px;
    padding-right: 45px;
    margin-top: 60px;
    margin-bottom: 125px;
  }
}
</style>
